import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {getWindow} from 'ssr-window';
import FormElementError from '@spothero/ui/form-element-error';
import Label from '@spothero/ui/label';
import StripeUtils from 'utils/stripe';

const window = getWindow();

export default class StripeCreditCardElement extends Component {
    static propTypes = {
        labelText: PropTypes.string,
        removeLabel: PropTypes.bool,
    };
    static defaultProps = {
        labelText: 'Card Number',
    };
    state = {
        stripeElementsCardError: null,
    };

    async componentDidMount() {
        if (!window.StripeElements) {
            await StripeUtils.init();
        }

        // multiple re-renders could cause this to be undefined due to the nature of the async/await and loading of stripe above so protect against it
        if (!this._stripeCreditCardElement) {
            return;
        }

        if (!window.SHStripeCardElement) {
            /* eslint-disable require-atomic-updates */
            window.SHStripeCardElement = window.StripeElements.create('card', {
                style: {
                    base: {
                        fontFamily: '"Open Sans", sans-serif',
                        fontSize: '14px',
                        fontWeight: '300',
                        lineHeight: '19px',
                        color: '#5c7996',
                        '::placeholder': {
                            color: '#cbd4de',
                        },
                    },
                },
            });
            /* eslint-enable require-atomic-updates */
        }

        window.SHStripeCardElement.mount(this._stripeCreditCardElement);
        window.SHStripeCardElement.addEventListener(
            'change',
            this._onStripeCardElementChanged
        );
    }

    componentWillUnmount() {
        if (window.SHStripeCardElement) {
            window.SHStripeCardElement.unmount();
            window.SHStripeCardElement.removeEventListener(
                'change',
                this._onStripeCardElementChanged
            );
            window.SHStripeCardElement.destroy();
            window.SHStripeCardElement = null;
        }
    }

    _onStripeCardElementChanged = evt => {
        this.setState({
            stripeElementsCardError: evt.error ? evt.error.message : null,
        });
    };

    render() {
        const {labelText, removeLabel} = this.props;
        const {stripeElementsCardError} = this.state;
        const cardFormElementClasses = classNames(
            'StripeCreditCardElement',
            'TextInput',
            'FormElement',
            {'FormElement-contains-error': stripeElementsCardError}
        );

        return (
            <div className={cardFormElementClasses}>
                {!removeLabel && <Label>{labelText}</Label>}
                <div
                    ref={node => {
                        this._stripeCreditCardElement = node;
                    }}
                    className="FormElement-item"
                />
                {stripeElementsCardError && (
                    <FormElementError>
                        {stripeElementsCardError}
                    </FormElementError>
                )}
            </div>
        );
    }
}
